import axios, { AxiosInstance } from 'axios';

export class Main {
  /// 应用ID
  clientId = '428a8310cd442757ae699df5d894f051';
  iosDownloadUrl = 'https://apps.apple.com/cn/app/1570110041';
  api: AxiosInstance = axios.create({
    // baseURL: 'http://192.168.1.52:9080',
    baseURL: 'https://5g.100861.net/api',
    // baseURL: 'http://192.168.0.137:8099',
    timeout: 120000,
    headers: { clientId: this.clientId },
  });
  privateKey = 'CY1zFymNm5xqT8KH';
  // appId = 'wx1ab6b4db2a374e5e';
  // 网上营业厅zsy
  appId = 'wxffe02df0fe84293e';

  openId: string = '';
  isIos14: boolean = false;
  enterUrl: string = '';
  isWexin: boolean = false;

  /**  登录token */
  loginToken?: string = '';

  /** 悬浮客服按钮位置是否写入  */
  customerPositionWrite: boolean = false;
  /** 悬浮客服按钮位置 左  */
  customerLeft: number = 0;
  /** 悬浮客服按钮位置 上  */
  customerTop: number = 0;

  init() {
    let ua = window.navigator.userAgent.toLowerCase();
    const ver = ua.match(/cpu iphone os (.*?) like mac os/);
    this.isIos14 = ver ? Number(ver?.[1].split('_')[0]) >= 14 : false;
    this.isWexin = ua.includes('micromessenger');
    let token = localStorage.getItem(AppLocalKey.loginToken);
    if (token) {
      this.loginToken = token;
      main.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }

  pic(name: string) {
    return '/pic/' + name;
  }
}
const main = new Main();
export default main;

export class AppLocalKey {
  /** 登录 token */
  static loginToken = 'loginToken';
  /** 邀请页面配置  */
  static pageInviteConfig = 'page.invite.config';
  /** 客服链接 */
  static customerH5 = 'customer.online.h5';
}
